<template>
  <div class="w-full height-100">
    <el-dialog
      title=""
      :visible.sync="isShowAddManagement"
      :direction="direction"
      :before-close="handleIsShowAddManagementClose()"
      width="30%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Add Order</h3></template
      >
      <div v-if="isshowform">
        <div>
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Order Status</p>
            <el-select
              filterable
              v-model="orderStatus"
              placeholder="Select..."
              class="w-full mt-1"
            >
              <el-option
                v-for="item in orderStatusOption"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>

          <div class="mt-6">
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Payment Status</p>
            <el-select
              filterable
              v-model="paymentStatus"
              placeholder="Select..."
              class="w-full mt-1"
            >
              <el-option
                v-for="item in paymentStatusOption"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>

          <div class="mt-6">
            <p class="fsize14 font-semibold text-4f4f4f mb-0">First Name</p>
            <el-select
              filterable
              v-model="firstNameSelect"
              placeholder="Select..."
              class="w-full mt-1"
            >
              <el-option
                v-for="item in users"
                :key="item._id"
                :label="item.fullName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-6">
            <p class="fsize14 font-semibold text-4f4f4f mb-0">AWB No</p>
            <el-input
              placeholder="Enter..."
              v-model="AWBno"
              class="w-full mt-2"
            ></el-input>
          </div>

          <div class="mt-6">
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Comment</p>
            <el-input
              type="textarea"
              placeholder="Enter..."
              v-model="comment"
              class="w-full mt-2"
            ></el-input>
          </div>
        </div>
      </div>

      <div v-if="!isshowform">
        <div>
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Select Product</p>
            <el-select
              filterable
              allow-create
              v-model="productId"
              @change="selectedProduct"
              placeholder="Select..."
              class="w-full mt-1"
            >
              <el-option
                v-for="item in productDetails"
                :key="item._id"
                :label="item.productName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>

          <div class="grid grid-cols-2 gap-4 mt-6" v-if="productId">
            <div>
              <p class="fsize14 font-semibold text-4f4f4f mb-0">
                {{ selectedProd.attributesId[0].name }}
              </p>
              <el-select
                filterable
                v-model="selectedAttribute"
                @change="displayVariation"
                placeholder="Select..."
                class="w-full mt-1"
              >
                <el-option
                  v-for="item in selectedProd.productImageId"
                  :key="item.valueName"
                  :label="item.valueName"
                  :value="item.valueName"
                >
                </el-option>
              </el-select>
            </div>

            <div>
              <p class="fsize14 font-semibold text-4f4f4f mb-0">
                {{ selectedProd.attributesId[1].name }}
              </p>
              <el-select
                filterable
                v-model="selectedVariation"
                placeholder="Select..."
                class="w-full mt-1"
              >
                <el-option
                  v-for="item in filteredVariation"
                  :key="item._id"
                  :label="item.variationValueName"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <vs-button class="bg-success mt-4 fsize12 px-8" @click="addProduct"
            >Save</vs-button
          >
        </div>

        <div class="mt-12" v-if="!choosedProduct.lenght >= 1">
          <div
            class="border p-3 rounded-6px mb-4"
            v-for="item in choosedProduct"
            :key="item"
          >
            <h2 class="font-semibold fsize16">
              {{ item.productName }}
            </h2>

            <div class="flex justify-between mt-4">
              <p class="font-semibold">
                {{ item.attribute }}-
                <span class="text-8f8f8f">{{ item.attributeVal }}</span>
              </p>

              <p class="font-semibold">
                {{ item.variation }}-
                <span class="text-8f8f8f">{{ item.variationVal }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-2 justify-center mt-8">
        <p
          @click="isshowform = false"
          :class="[
            isshowform ? 'bg-gray text-primary ' : 'bg-primary text-primary',
          ]"
          class="w-3 h-3 block cursor-pointer rounded-full"
        ></p>
        <p
          @click="isshowform = true"
          :class="[
            isshowform ? 'bg-primary text-primary ' : ' bg-gray text-primary ',
          ]"
          class="w-3 h-3 block bg-gray rounded-full cursor-pointer"
        ></p>
      </div>

      <div class="flex justify-center mt-10">
        <vs-button
          class="bg-primary text-white font-semibold py-3 fsize14 px-12 sm-fsize14"
          @click="createOrder"
        >
          Submit
        </vs-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isShowOrder"
      :direction="direction"
      :before-close="handleIsShowOrderClose"
    >
      <template slot="title"
        ><h3 class="fsize18 Add mb-0 Products text-white">
          Product Details
        </h3></template
      >
      <div>
        <MenuProductTable
          :previewOrderedDetails="previewOrderedDetails"
          :orderData="orderData"
        />
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Order Management
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <!-- <div class="mt-4">
        <div class="relative">
          <el-input
            placeholder="Search"
            v-model="search"
            class="rounded-none w-full"
          ></el-input>
          <div class="absolute top-0 right-0 mt-2 mr-2">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
      </div> -->
      <!-- <div class="flex flex items-center justify-end"> -->
      <el-input v-model="search" placeholder="Search here..." class="w-3/2" />

      <!-- <vs-button @click="isShowAddManagement = true" class="rounded-full"
          >Add Order
        </vs-button>
      </div> -->

      <div>
        <el-table
          :data="orderDetails"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column prop="orderId" label="Order ID" min-width="150px">
          </el-table-column>

          <el-table-column
            prop="orderStatus"
            label="Order Status"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <OrderStatus :itemData="row" @getOrders="getOrders" />
              <!-- {{ row.orderStatus }} -->
            </template>
          </el-table-column>

          <el-table-column
            prop="paymentStatus"
            label="Payment Status"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <div
                v-if="row.transactionId && row.transactionId.transactionStatus"
              >
                <el-tag
                  v-if="row.transactionId.transactionStatus === 'In-Process'"
                  type="warning"
                  >{{ row.transactionId.transactionStatus }}</el-tag
                >
                <el-tag
                  v-else-if="row.transactionId.transactionStatus === 'Success'"
                  type="success"
                  >{{ row.transactionId.transactionStatus }}</el-tag
                >
                <el-tag
                  v-else-if="row.transactionId.transactionStatus === 'Failed'"
                  type="danger"
                  >{{ row.transactionId.transactionStatus }}</el-tag
                >
                <el-tag
                  v-else-if="row.transactionId.transactionStatus === 'Pending'"
                  type=""
                  >{{ row.transactionId.transactionStatus }}</el-tag
                >
              </div>
              <div v-else>
                <el-tag type="info">Missing</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="firstName" label="Name" min-width="150px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.userData.fullName }}</P>
            </template>
          </el-table-column>

          <el-table-column prop="AWBno" label="AWB No" min-width="150px">
          </el-table-column>
          <el-table-column
            prop="orderStatus"
            label="Order Details"
            min-width="150px"
          >
            <template v-slot="{ row }">
              <p
                @click="viewOrderedProduct(row)"
                class="text-underline fsize14 cursor-pointer"
              >
                View
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderInvoice"
            label="Order Invoice"
            min-width="150px"
          >
            <template v-slot="{ row }">
              <p
                @click="handleClick('invoice', row)"
                class="text-underline text-success fsize14 cursor-pointer"
              >
                View Invoice
              </p>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6" v-if="totalRows > 0">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="totalRows"
            :page-size="perPage"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
import { mapState } from "vuex";
import OrderStatus from "./OrderStatus.vue";
import MenuProductTable from "./MenuProductTable";
export default {
  data() {
    return {
      direction: "rtl",
      search: "",
      isShowAddManagement: false,
      isShowOrder: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      firstNameSelect: "",
      paymentStatus: "",
      orderStatus: "",
      productId: "",
      selectedProd: {},
      selectedVariation: "",
      selectedAttribute: "",
      choosedProduct: [],
      AWBno: "",
      comment: "",
      previewOrderedDetails: {},
      orderData: {},
      paymentStatusOption: ["pending", "success", "cancelled", "failed"],
      orderStatusOption: [
        "Order Received",
        "Dispatched",
        "Shipped",
        "Cancelled",
      ],
      filteredVariation: [],
      isshowform: false,
    };
  },
  components: {
    MenuProductTable,
    OrderStatus,
  },
  methods: {
    handleIsShowAddManagementClose() {
      this.isShowAddManagement = false;
    },
    handleIsShowOrderClose() {
      this.isShowOrder = false;
    },
    handleClick(name, data) {
      // this.$store.state.EcomOrder.selectedOrder = data;
      this.$store.commit("EcomOrder/SET_SELECTED_ORDER", data);
      this.$router.push({ name: name });
    },

    async getAllUsers() {
      try {
        const data = await this.$store.dispatch("user/getAllUsers", {
          perPage: this.perPage,
          page: this.currentPage,
        });
        // this.perPage =
        this.$store.commit(
          "manageUser/GET_ALL_USER_DETAILS",
          data.registeredUser
        );
        // this.users = data.registeredUser;
      } catch (error) {}
    },
    selectedProduct() {
      for (let i = 0; i < this.productDetails.length; i++) {
        if (this.productDetails[i]._id == this.productId) {
          this.selectedProd = this.productDetails[i];
        }
      }
      // for (let i = 0; i < this.selectedProd.variationId.length; i++) {
      //   if (
      //     !this.filteredVariation.includes(
      //       this.selectedProd.variationId[i].variationValueName
      //     )
      //   ) {
      //     this.filteredVariation.push(
      //       this.selectedProd.variationId[i].variationValueName
      //     );
      //   }
      // }
    },
    displayVariation() {
      let arr = [];
      this.filteredVariation = [];
      for (let i = 0; i < this.selectedProd.variationId.length; i++) {
        if (
          this.selectedProd.variationId[i].attributeValueName ==
          this.selectedAttribute
        ) {
          this.filteredVariation.push(this.selectedProd.variationId[i]);
        }
      }
    },
    addProduct() {
      let varri = "",
        arrt = "";

      for (let i = 0; i < this.selectedProd.variationId.length; i++) {
        if (this.selectedProd.variationId[i]._id == this.selectedVariation) {
          varri = this.selectedProd.variationId[i].variationValueName;
        }
      }
      for (let i = 0; i < this.selectedProd.productImageId.length; i++) {
        if (
          this.selectedProd.productImageId[i].valueName ==
          this.selectedAttribute
        ) {
          arrt = this.selectedProd.productImageId[i]._id;
        }
      }
      this.choosedProduct.push({
        productName: this.selectedProd.productName,
        productId: this.selectedProd._id,
        attributeVal: this.selectedAttribute,

        variationId: this.selectedVariation,
        attribute: this.selectedProd.attributesId[0].name,
        variation: this.selectedProd.attributesId[1].name,
        variationVal: varri,
        attributeImageId: arrt,
      });
      this.productId = "";
      this.selectedVariation = "";
      this.selectedAttribute = "";
    },
    async createOrder() {
      let userData = {};
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i]._id == this.firstNameSelect) {
          userData = this.users[i];
        }
      }
      const payload = {
        userData: userData,
        item: this.choosedProduct,
        AWBno: this.AWBno,
        comment: this.comment,
        orderStatus: this.orderStatus,
        paymentStatus: this.paymentStatus,
      };
      await this.$store.dispatch("EcomOrder/addOrder", payload);
      await this.$store.dispatch("EcomOrder/getOrder");
      this.isShowAddManagement = false;
    },
    viewOrderedProduct(data) {
      this.isShowOrder = true;
      this.previewOrderedDetails = data.item;
      this.orderData = data;
      // console.log(data.item);
      this.$store.commit("EcomOrder/SET_SELECTED_ORDER", data);
    },
    async getOrders() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });
      let data = await this.$store.dispatch("EcomOrder/getOrder", payload);
      this.totalRows = data.data.totalCount;
      // console.log(this.orderDetails);
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  watch: {
    async currentPage() {
      await this.getOrders();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getOrders();
      }, 500),
    },
  },
  computed: {
    ...mapState("user", ["users"]),
    ...mapState("EcomProduct", ["productDetails"]),
    ...mapState("EcomOrder", ["orderDetails"]),
  },

  mounted() {
    this.getAllUsers();
    this.$store.dispatch("EcomProduct/getProduct");
    this.getOrders();
  },
};
</script>
